import React, { ReactNode } from 'react';
import { FacebookSDKScript } from '../FacebookSDKScript';
import { FacebookConnectScript } from '../FacebookConnectScript';
import { PinterestScript } from '../PinterestScript';
import { DailyWagSiteNavigation } from '../DailyWagSiteNavigation';
import { FACEBOOK_APP_ID } from '../../constants/app';
import { SITE_HEADER_DESKTOP_HEIGHT, SITE_HEADER_MOBILE_HEIGHT, SITE_HEADER_TABLET_HEIGHT } from '../../wag-react/components/site-navigation/constants';
import { SiteFooter } from '../../wag-react/components/site-navigation/SiteFooter/SiteFooter';
import { Grid } from '../../wag-react/core-components/grid';
import { Box } from '../../wag-react/next-components/box';
export type Props = {
  children?: ReactNode;
  hideFooter?: boolean;
};
export const DailyWagLayout = ({
  children,
  hideFooter = false
}: Props) => <Grid height="100%" data-testid="daily-wag-layout" data-sentry-element="Grid" data-sentry-component="DailyWagLayout" data-sentry-source-file="index.tsx">
    <FacebookSDKScript facebookAppId={FACEBOOK_APP_ID} data-sentry-element="FacebookSDKScript" data-sentry-source-file="index.tsx" />
    <FacebookConnectScript data-sentry-element="FacebookConnectScript" data-sentry-source-file="index.tsx" />
    <PinterestScript data-sentry-element="PinterestScript" data-sentry-source-file="index.tsx" />

    <DailyWagSiteNavigation data-sentry-element="DailyWagSiteNavigation" data-sentry-source-file="index.tsx" />

    <Box flex="1" pt={[`${SITE_HEADER_MOBILE_HEIGHT}px`, `${SITE_HEADER_TABLET_HEIGHT}px`, `${SITE_HEADER_DESKTOP_HEIGHT}px`]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      {children}
    </Box>
    {!hideFooter && <SiteFooter />}
  </Grid>;